module.exports = __webpack_public_path__ + "img/乌镇人民公园1.8c85b6b6.jpg";